import { z } from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { membershipRole } from "@shyne/shared/api";
import { FormCreator, FormFieldDef } from "@/components/shared/form-creator";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { roleOptions } from "@/lib/permissions/member-roles";
import { useTeamMembers } from "../teammembers.hooks";

const schema = z.object({
  name: z.string(),
  email: z.string().email("Invalid email"),
  role: membershipRole,
});

type FormValues = z.infer<typeof schema>;

export function InviteMemberModal({ open, onOpenChange }: { open: boolean; onOpenChange: (o: boolean) => void }) {
  const { invite, organizationType } = useTeamMembers();
  const form = useForm<FormValues>({ resolver: zodResolver(schema), defaultValues: { email: "" } });

  const onSubmit = async (vals: FormValues) => {
    await invite(vals.name, vals.email, vals.role);
    form.reset();
    onOpenChange(false);
  };

  const fields: FormFieldDef[] = [
    { type: "text", name: "name", label: "Name", required: true },
    { type: "email", name: "email", label: "Email", required: true },
    { type: "select", name: "role", label: "Role", required: true, options: roleOptions(organizationType) },
  ];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Invite New Member</DialogTitle>
        </DialogHeader>
        <FormCreator form={form} onSubmit={onSubmit} formDefinition={fields} buttonText="Send Invite" />
        <DialogFooter />
      </DialogContent>
    </Dialog>
  );
}
